import { useEffect, useState } from 'react';
import { SelectArrayInput, useTranslate, useListContext } from 'react-admin';

import { filtersDataProvider } from '@/dataProvider';
import { ICohortsSelect } from '@/types';

function EmployeesCohortAutocompleteInput(): JSX.Element {
  const t = useTranslate();
  const { filterValues } = useListContext();

  const [cohortsData, setCohortsData] = useState<
    { id: string; name: string; companyId?: string }[]
  >([]);
  const [cohortsFilter, setCohortsFilter] = useState<ICohortsSelect[]>([]);

  const getCohortsFilter = async (): Promise<void> => {
    const data = await filtersDataProvider.getCohorts();

    setCohortsData([
      { id: 'default', name: t('resources.employees.default_cohort_name') },
      ...(data || []),
    ]);
  };

  useEffect(() => {
    void getCohortsFilter();
  }, []);

  useEffect(() => {
    if (cohortsData?.length > 0) {
      setCohortsFilter(cohortsData);
    }

    if (filterValues?.companies?.length > 0) {
      setCohortsFilter(
        cohortsData.filter(
          item => !item.companyId || filterValues.companies.includes(item.companyId),
        ),
      );
    }
  }, [filterValues, cohortsData]);

  return (
    <>
      <SelectArrayInput
        label="resources.employees.cohort_filter"
        source="cohorts"
        optionValue="id"
        choices={cohortsFilter}
        sx={{
          width: 300,
          ['& .RaSelectArrayInput-chips']: {
            overflow: 'hidden',
            display: 'flex',
            flexWrap: 'nowrap',
            width: 250,
          },
        }}
        options={{
          renderValue: (selected: any) =>
            selected
              .map((item: any) => cohortsFilter.find(cohort => cohort.id === item)?.name)
              .filter((item: any) => !!item)
              .join(', '),
        }}
      />
    </>
  );
}

export default EmployeesCohortAutocompleteInput;
